import React from "react";

import Portrait from "./Portrait";

import MultibetGenerator from "../../MultibetGenerator";
import DiamondDiv from "../../DiamondDiv";
import SlBet from "../../SlBet";

import { mouseOver, mouseLeave } from "@/modules/mouseInteractions";
import { rouletteReds } from "@/modules/commonMobile";
import nth0 from "@/modules/nth0";
import Nnary from "@/modules/Nnary";
import zeroFill from "@/modules/zeroFill";
import nary from "@/modules/nary";

import { IGameTableType } from "@/types/GlobalTypes";

import "./index.scss";

export default class M36 extends React.Component<IGameTableType> {
	state = { activeHover: "" };

    render() {
        // console.log("m36 hover", this.state.activeHover);

        //Todo: correct winStatement={false}

        const { langdata, maximised, mobile, portrait } = this.props;
        const win = this.props.win ? Number(this.props.win) : null;
        
        const showPrize = maximised || mobile;

        const cols = Nnary(1, 34, 3);

		const commonBetProps = {
			pcode: this.props.pcode,
			chipBase: this.props.chipBase,
			mobile: this.props.mobile,
			bets: this.props.bets,
			insertBet: this.props.insertBet,
			betOutOfBounds: this.props.betOutOfBounds,
			langStr: langdata.language_code
        };
        
        //Only use this if the SlBet has hover parameters
        const commonHoverProps = {
            hasHover: true,
            mouseOver: mouseOver.bind(this),
            mouseLeave: mouseLeave.bind(this)
        };

        const commonMultiBetProps = {
            ...commonBetProps,
            ...commonHoverProps
        }

        if (portrait)
            return <Portrait
                cols={cols}
                {...this.props} />

        return <div className="sl-table table-m36">
            <div className="big-centre">
            {
                [2, 1, 0].map(num =>
                    <div key={"m36_row_g_" + num}>
                    {
                        cols.map(col => {
                            const computed = col + num;
                            const bet = zeroFill(computed, 2);

                            const { activeHover } = this.state;

                            return (
                                <SlBet key={"m36_g_" + num + "_" + col}

                                    classes={"sl-bet " + (rouletteReds.indexOf(+bet) >= 0 ? "sl-red-lighten" : "sl-black-lighten")}
                                    bet={bet}
                                    group="n"
                                
                                    hoverStatement={
                                        //multibet
                                        (activeHover.indexOf(zeroFill(computed, 2)) >= 0 && activeHover.indexOf(" ") < 0) ||

                                        //12-columns
                                        (
                                            activeHover.indexOf(" 12") >= 0 &&
                                            computed >= ((+activeHover[0] - 1) * 12 + 1) &&
                                            computed <= (+activeHover[0] * 12)
                                        ) ||

                                        //side
                                        (activeHover === `${nth0(num)} Row`) ||
                                        
                                        //small/big
                                        (activeHover === "Small" && computed <= 18) ||
                                        (activeHover === "Big" && computed >= 19) ||

                                        //odd/even
                                        (activeHover === "Odd" && !!(computed % 2)) ||
                                        (activeHover === "Even" && !(computed % 2)) ||

                                        //red/black
                                        (activeHover === "Red" && rouletteReds.indexOf(computed) >= 0) ||
                                        (activeHover === "Black" && rouletteReds.indexOf(computed) < 0)
                                    }

                                    winStatement={win ? Number(win) === computed : false}
                                
                                    betLabel={computed + ""}
                                    betType={showPrize ? "1:34" : null}
                                
                                    {...commonBetProps}
                                />
                            );
                        })
                    }
                    </div>
                )
            }
                <div className="bottom">
                {
                    nary(3).map((num, numIdx) => 
                        <SlBet key={"m36_g_b_" + num}

                            classes="sl-bet sl-green-old"
                            bet={`${nth0(numIdx)} 12`}
                            group="n12"

                            winStatement={false}

                            betLabel={`${nth0(numIdx)} 12`}
                            betType={showPrize ? "1:1.9" : null}

                            {...commonBetProps}
                            {...commonHoverProps}
                        />
                    )
                }
                </div>

                <div className="bottom-6">
                {
                    ["Small", "Odd", "Red", "Black", "Even", "Big"].map((bet) =>
                        <SlBet key={"m36_g_b_" + bet}

                            classes="sl-bet sl-green-old"
                            bet={bet}
                            group="n50"

                            winStatement={false}

                            betLabel={
                                bet === "Red" || bet === "Black" ?
                                <DiamondDiv colour={bet === "Red" ? "#b83432" : "#1f2022"} /> :
                                ("txt_" + bet) in langdata ?
                                langdata["txt_" + bet] :
                                bet}
                            betType={showPrize ? "1:0.95" : null}

                            {...commonBetProps}
                            {...commonHoverProps}
                        />
                    )
                }
                </div>
            </div>

            <div className="side">
            {
                [2, 1, 0].map((num) =>
                    <SlBet key={"m36_g_" + num}

                        classes="sl-bet sl-green-old"
                        bet={`${nth0(num)} Row`}
                        group="n12"

                        winStatement={false}

                        betLabel={`${langdata["txt_row"]} ${num + 1}`}
                        betType={showPrize ? "1:1.9" : null}

                        {...commonBetProps}
                        {...commonHoverProps}
                    />
                )
            }
            </div>

            {/* MULTIBET STARTS HERE */}

            {
                /*
                    Pattern:
                    03,06  06,09
                    02,05  05,08
                */
            }
            <MultibetGenerator
                keyPattern={
                    Nnary(3, 1, -1).map(row =>
                        Nnary(0, 33, 3).map(cell => {
                            const computed = row + cell;
                            return `${zeroFill(computed, 2)},${zeroFill(computed + 3, 2)}`;
                        })
                    )
                }

                langdata={langdata}

                firstLeftPercent={85 / 12}
                firstTopPercent={10}

                leftSpace={85 / 12 + "%"}
                topSpace={"20%"}

                width={8}
                height={28}

                betGroup="n2"

                {... commonMultiBetProps}
            />

            {
                /*
                    Pattern:
                    02,03  05,06
                    01,02  04,05
                */
            }
            <MultibetGenerator
                keyPattern={
                    [2, 1].map(row =>
                        Nnary(0, 33, 3).map(cell => {
                            const computed = row + cell;
                            return `${zeroFill(computed, 2)},${zeroFill(computed + 1, 2)}`;
                        })
                    )
                }

                langdata={langdata}

                firstLeftPercent={85 / 24}
                firstTopPercent={20}

                leftSpace={85 / 12 + "%"}
                topSpace={"20%"}

                width={maximised ? 80 : 25}
                height={8}

                betGroup="n2"

                {... commonMultiBetProps}
            />

            {
                /*
                    Pattern:
                    02,03,05,06  05,06,08,09
                    01,02,04,05  04,05,07,08
                */
            }
            <MultibetGenerator
                keyPattern={
                    [2, 1].map(row =>
                        Nnary(0, 30, 3).map(cell => {
                            const computed = row + cell;
                            return `${zeroFill(computed, 2)},${zeroFill(computed + 1, 2)},` +
                                `${zeroFill(computed + 3, 2)},${zeroFill(computed + 4, 2)}`;
                        })
                    )
                }

                langdata={langdata}

                firstLeftPercent={85 / 12}
                firstTopPercent={20}

                leftSpace={85 / 12 + "%"}
                topSpace={"20%"}

                width={20}
                height={20}

                betGroup="n4"

                {... commonMultiBetProps}
            />

            { /* TOP BET PATTERNS */ }
            <MultibetGenerator
                keyPattern={[
                    Nnary(0, 30, 3).map(col =>
                        nary(3).map(cell =>
                            zeroFill(col + cell, 2)
                        ).join(",")
                    )
                ]}

                langdata={langdata}

                firstLeftPercent={85 / 24}
                firstTopPercent={0}

                leftSpace={85 / 12 + "%"}
                topSpace={"20%"}

                width={maximised ? 80 : 25}
                height={8}

                betGroup="n3"

                {... commonMultiBetProps}
            />

            <MultibetGenerator
                keyPattern={[
                    Nnary(0, 30, 3).map(col =>
                        nary(6).map(cell =>
                            zeroFill(col + cell, 2)
                        ).join(",")
                    )
                ]}

                langdata={langdata}

                firstLeftPercent={85 / 12}
                firstTopPercent={0}

                leftSpace={85 / 12 + "%"}
                topSpace={"20%"}

                width={20}
                height={20}

                betGroup="n6"

                {... commonMultiBetProps}
            />
        </div>;
    }
}